import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useEffect } from "react";
import { AUTH_COOKIE } from "@/constants";
import Cookies from "js-cookie";
import { PATH } from '@/routes/Paths';
export default function AutoLogin() {
    const { search } = useLocation();

    const parameters = new URLSearchParams(search);
    const access_token = parameters.get("access_token") || "";
    const project_id = parameters.get("project_id") || "";
    const navigate = useNavigate();

    const { setAuthToken } = useAuth();
    useEffect(() => {
        setAuthToken(access_token);
        const expires = new Date();
        expires.setDate(expires.getDate()+1);

        Cookies.set(AUTH_COOKIE, access_token, {
            expires: expires,
            secure: true,
            sameSite: 'Strict',
        });
        navigate(`${PATH.project}/${project_id}`);
    }, []);
    
    return null;
}